export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/573024819377?text=Hola%20Michael%2C%20me%20interesa%20tu%20trabajo"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-8 right-8 z-50 w-16 h-16 flex items-center justify-center bg-[#25D366] rounded-full animate-pulse-glow hover:scale-110 transition-transform duration-300 cursor-pointer"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl text-white"></i>
    </a>
  );
}
